const PrevIcon = () => {
  return (
    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.1781 15.1156C7.00935 15.1156 6.8406 15.0594 6.7281 14.9188L0.371851 8.45C0.118726 8.19688 0.118726 7.80313 0.371851 7.55L6.7281 1.08125C6.98123 0.828126 7.37498 0.828126 7.6281 1.08125C7.88123 1.33438 7.88123 1.72813 7.6281 1.98125L1.72185 8L7.65623 14.0188C7.90935 14.2719 7.90935 14.6656 7.65623 14.9188C7.48748 15.0313 7.34685 15.1156 7.1781 15.1156Z"
        fill="#637381"
      />
    </svg>
  );
};

export default PrevIcon;
